import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  pendingStoreActions: [],
  isMenuExpanded: false,
  isLoading: false,
  modal: {
    isVisible: false,
    content: null,
    header: null,
    size: 'medium',
    widgetKey: null,
  },
  globalSettings: {
    dictionary: [],
  },
};

const getters = {
  pendingStoreActions: state => ({
    includes(pendingActions = []) {
      const _pendingActions = pendingActions;
      return state.pendingStoreActions.some(a => _pendingActions.includes(a));
    },
  }),
  isMenuExpanded: state => state.isMenuExpanded,
  isLoading: state => state.isLoading,
  globalSettings: state => state.globalSettings,
  modal: state => state.modal,

  // dictionary
  dictionaryBillingEffect: state => state.globalSettings.dictionary
    .filter(item => item.category === 'connection-effect'),
  dictionaryBillingDirection: state => state.globalSettings.dictionary
    .filter(item => item.category === 'connection-direction'),
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};

export default Module;
